export default __webpack_public_path__ + "static/media/2.754bae4b.webp";